import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import Task from 'components/projects/taskList/components/Task';
import TaskListSectionHeader from 'components/projects/taskList/components/TaskListSectionHeader';

import {
  useSectionlessTemplate,
  useSectionsTemplate,
} from '../hooks/templates';
import Spinner from 'components/shared/DesignSystem/Spinner';

const TasksLoadingSpinner = styled(Spinner)`
  margin: 10px auto;
`;

const TemplateBodyContent = ({ projectNodeId }) => {
  const currentTemplateId = useSelector(
    ({ todos }) => todos.templates.currentTemplateId,
  );

  const {
    sectionlessTemplateTasks,
    sectionlessTemplateTasksLoading,
  } = useSectionlessTemplate(currentTemplateId);
  const {
    taskListTemplateSections,
    taskListTemplateSectionsLoading,
  } = useSectionsTemplate({ templateId: currentTemplateId });

  const renderSecionlessTasks = () => {
    return !sectionlessTemplateTasksLoading ? (
      sectionlessTemplateTasks.map((task) => {
        return (
          <Task
            key={task.id}
            task={task}
            listId={currentTemplateId}
            viewOnly
            templateProjectId={projectNodeId}
            isTemplate
            isPreviewingTemplate
          />
        );
      })
    ) : (
      <TasksLoadingSpinner />
    );
  };

  const renderSections = () => {
    return !taskListTemplateSectionsLoading ? (
      taskListTemplateSections.map((section, index) => {
        return (
          <Fragment key={section.id}>
            <div key={section.id || `new-template-section${index}`}>
              <TaskListSectionHeader
                listId={currentTemplateId}
                section={section}
                isTemplate
                showMenu
                showReorderOption={taskListTemplateSections.length > 1}
                showDeleteOption
                zIndex={100}
              />
              {section.taskTemplates.nodes.map((task) => {
                return (
                  <Task
                    key={task.id}
                    task={task}
                    sectionId={section.id}
                    listId={currentTemplateId}
                    viewOnly
                    isTemplate
                    isPreviewingTemplate
                  />
                );
              })}
            </div>
          </Fragment>
        );
      })
    ) : (
      <TasksLoadingSpinner />
    );
  };

  return (
    <>
      {renderSecionlessTasks()}
      {renderSections()}
    </>
  );
};

TemplateBodyContent.propTypes = {
  projectNodeId: PropTypes.string.isRequired,
};

export default TemplateBodyContent;
